export default "__VITE_ASSET__Coj1cwdU__"